import React, { FC } from 'react';

import { HomePageOptionsCardProps } from '.';
import Button from '../../Button';

export const HomePageOptionsCardTemplate: FC<HomePageOptionsCardProps> = ({
    className,
    routeTitle,
    onRedirect,
    buttonText,
    imageUrl,
}): JSX.Element => {
    return (
        <div className={className} data-testid="TESTING_HOMEPAGE_OPTION_CARD">
            <figure className="home-optionCard">
                <figcaption className="home-optionCard--title">{routeTitle}</figcaption>
                <img className="home-optionCard--image" title={routeTitle} src={imageUrl} />
            </figure>

            <Button data-testid="TESTING_ROUTES_PICK" onClick={onRedirect} primary>
                {buttonText}
            </Button>
        </div>
    );
};
